/**
 * Cabecera verde de landing — GEN-PX-018. Componente común (Estrategia hoy; Auditoría, Admin, Normas, Agentes, Personas y
 * Ficheros después, HU 024–029). Solo pinta: el contenido (agente, título, texto, botón) lo emite el kernel, sin LLM.
 * `agente` = { nombre, rol, foto } (foto ya resuelta a blob URL, o null → iniciales).
 * GEN-PX-024: `cifras` = [{ texto, onClick }] opcional; cada `texto` es un fragmento literal de `texto` que se pinta como
 * enlace (cifra clicable). Sin `cifras`, el texto sale tal cual.
 */
import { Avatar } from '../despacho/ui.jsx'

const iniciales = nombre => (nombre ?? '').split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase()

// Parte `texto` por los fragmentos de las cifras (en orden de aparición) y los pinta como botón-enlace.
function conCifras(texto, cifras) {
  const partes = []
  let resto = texto
  for (const c of cifras) {
    const i = resto.indexOf(c.texto)
    if (i < 0) continue
    if (i > 0) partes.push(resto.slice(0, i))
    partes.push(<button key={c.texto} type="button" className="dk-cab__enlace" onClick={c.onClick}>{c.texto}</button>)
    resto = resto.slice(i + c.texto.length)
  }
  if (resto) partes.push(resto)
  return partes
}

export default function CabeceraLanding({ agente = null, titulo, texto, boton = null, cifras = null }) {
  return (
    <header className="dk-cab">
      {agente && <Avatar foto={agente.foto} iniciales={iniciales(agente.nombre)} nombre={agente.nombre} tamano={84} activo agente />}
      <div className="dk-cab__texto">
        {agente && <div className="dk-cab__agente"><b>{agente.nombre}</b>{agente.rol ? ` · ${agente.rol}` : ''}</div>}
        <h1 className="dk-cab__h1">{titulo}</h1>
        <p>{cifras?.length ? conCifras(texto, cifras) : texto}</p>
        {boton && <button type="button" className="dk-cab__boton" onClick={boton.onClick}>{boton.etiqueta}</button>}
      </div>
    </header>
  )
}
